import React from "react";
import "../Products/Products.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
const MetalDetection = ({ title, imageSrc, description }) => {
  const MetalDetectionDetails = [
    {
      headingname: "Bundle Note Counting",
      detailsname:"The Banknote Counter counts and detects notes previously sorted by denomination. The .....",
      imageSource:process.env.PUBLIC_URL + "assets/images/Products/currency-1.png",
    },
    {
      headingname: "Fake Note Detector",
      detailsname:"To spot a fake note, you can check the typography of the words 'Reserve Bank of India'. ........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/currency-2.png",
    },
    {
      headingname: "Cash Note Counting ",
      detailsname:"A currency counting machine with a fake note detector employs various ways to detect ......",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/currency-3.png",
    },
    {
      headingname: "Electronic Safe",
      detailsname:"Electronic safe locks function similarly to traditional locks, but they may be unlocked......",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/currency-4.png" ,
    },
    {
      headingname: "Paper Shredder",
      detailsname:"A paper shredder is a mechanical device used to cut sheets of paper into either strips or .......",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/currency-5.png ",
    },
  ];
  return (
    <>
      <section className="CCTV-System">
        <div className="container">
          <div className="Heading-cctv">
            <div className="heading-about text-center">
              <h4>Currency Counting Machine & Electronic Safe</h4>
            </div>
            <div className="borders-eight d-flex justify-content-center">
              <div className="border-red"></div>
              <div className="border-line "></div>
            </div>
          </div>

          <div className="row justify-content-center">
            {MetalDetectionDetails.map((item, index) => (
              <div key={index} className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-12 mt-4 mt-xl-5 g-5">
                <Card className="IR-Camera mb-3">
                  <Card.Img variant="top" />
                  <div className="Heading-Main">
                    <h1 className="dome-camera">{item.headingname}</h1>
                  </div>

                  <div className="camera-border"></div>
                  <div className="IR-camera-img">
                    <img src={item.imageSource} className="camera-img" />
                  </div>
                  <Card.Body className="IR-Camera-body">
                    <Card.Text>{item.detailsname}</Card.Text>
                    <div className="read-button">
                      <Button variant="read">Read More</Button>
                      <div className="read-border"></div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MetalDetection;
